import React from 'react';
var AkDateLozenge = /*#__PURE__*/React.lazy(function () {
  return import('@atlaskit/date').then(function (module) {
    return {
      default: module.Date
    };
  });
});
var DateLozenge = function DateLozenge(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/React.createElement(AkDateLozenge, {
    value: value
  });
};
export default DateLozenge;
export var DateLozengeFn = function DateLozengeFn(_ref2) {
  var props = _ref2.props;
  var _ref3 = props,
    value = _ref3.value;
  return /*#__PURE__*/React.createElement(DateLozenge, {
    value: value
  });
};